/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/prefer-regexp-exec */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { isObject } from 'lodash';
import { Toast } from '@hb/coffee';
import { getFinanceUser } from '@/api';
import {
  getDeviceFingerprintHash, getDeviceInfo, getOldDeviceInfo, closeWebView, getCityInfo, logout, getSystemInfo,
} from '@/api/native/utils';
import { LocalEnum } from '@/enums/local';
import store, { updateModuleState, usePersistedState } from '@/store';
import { moduleExpose, ubtButton } from '@/shared/utils/ubt';
import { gatewayUrl, isH5App } from '@/constant';
import { landData } from '@/shared/utils/landData';
import UserDeviceApi from '@/api/userDevice';
import { versionCompare } from '@/shared/utils/versionCompare';
import { local, session } from '@/shared/utils/storage';
import platform from '@/shared/utils/platform';
import { getTokenAndKey } from '@/api/native/userInfo';
import NativeApi from '@/api/native';
import { checkCurrentRepayBill } from '@/api/homeV2Status';
import { cehckUserToken } from '@/api/native/aliMP';
import router from '@/router';
import { RouterH5Enum, RouterV2Enum } from '@/router/router-names';
import DingTalkApi from '@/api/ding-talk';
import { ErrorTypeEnum } from '@/enums/codeError';
import { getUnionAuthCode, unionAuth } from '@/shared/h5-login/unionLogin';
import { getSkUserAuth, removeContainerLoading } from '@/api/native/container';
import { formatToastOption } from '../formatToast';
import URLUtils from '../URLUtils';


const pkg = require('@/../package.json');

const versionMatches = navigator.userAgent.match(/version=([\d.]*)/);
export const appVersion = (versionMatches && versionMatches[1]) || '5.13.0';

// 判断设备信息是否非空
const isUserDeviceNotEmpty = (params: unknown): boolean => isObject(params) && Object.keys(params).length > 0;

/** 判断当前是否走联登服务逻辑 */
const IS_UNION_LOGIN = !!getUnionAuthCode();

export default class Bootstrap {
  static async init(isNeedLandData = true): Promise<void> {
    // 记录访问的source信息以及将链接中的m映射成手机号自动填充到h5登录页面
    if (isNeedLandData) {
      landData.init();
    }

    // 生成或同步缓存中的h5UUID数据，在埋点数据中使用
    Bootstrap.initH5UUID();
    // 校验token时效性，只在小程序中调用
    if (platform.isAlipayMini) {
      await Bootstrap.checkUserInfoToken();
    }

    // 哈啰APP及支付宝小程序、微信小程序、用户联登场景，调用同一套逻辑，保持登录逻辑的一致性
    if (platform.isHelloApp
      || platform.isAlipayMini
      || platform.isWechatMini
      || IS_UNION_LOGIN) {
      /** 组合用户登录信息 包含 客户端哈啰账户和金融账户信息 */
      const { hello, sk } = await getSkUserAuth({ needRefresh: false });
      if (hello && sk) {
        // 运营在哈啰App和支付宝小程序中
        await Bootstrap.initHelloUser(hello);
        await Bootstrap.throughGate(sk);
      } else {
        // 运营在哈啰App和支付宝小程序中
        await Bootstrap.initHelloUser();
        await Bootstrap.throughGate();
      }


      if (platform.isHelloIosApp && versionCompare(appVersion, '5.87.0') >= 0) {
        NativeApi.webViewInteractivePopDisabled(true);
        NativeApi.nativeInteractivePopDisabled(true);
      }

      await Bootstrap.getCurrentRepayUser();
    } else {
      Bootstrap.hydrateAuthDataForH5App();
    }

    // 登录完成之后,调取位置信息
    Bootstrap.initEnv();
  }

  static async getCurrentRepayUser(): Promise<void> {
    try {
      const repayState = await checkCurrentRepayBill();
      if (repayState) {
        updateModuleState('base', {
          repayState,
        });
      }
    } catch (e) {
      // console.log(e)
    }
  }

  static async initHelloUser(helloUserData?: NativeModel.OriginUserInfo): Promise<void> {
    try {
      const originUserInfo = IS_UNION_LOGIN
        // 如果链接上携带authCode, 调用获取用户联登接口获取用户平台token
        ? await unionAuth()
        // 仅作获取token的操作，登陆跳转，移至路由守卫器中实现
        : helloUserData || await getTokenAndKey(false);


      if (originUserInfo && originUserInfo.token) {
        updateModuleState('base', {
          originUserInfo,
        });
      }
      ubtButton('Bootstrap', 'finance_alipay_agree', 'source', landData.getSouce());
    } catch (e) {
      ubtButton('Bootstrap', 'finance_alipay_reject', 'source', landData.getSouce());
      closeWebView();
    }
  }

  // 检测用户token
  static async checkUserInfoToken(): Promise<void> {
    try {
      await cehckUserToken({});
    } catch (e) {
      // console.log(e);
    }
  }

  // 初始化用户的地理位置信息以及设备信息
  static async initEnv(): Promise<void> {
    try {
      // app及支付宝小程序域外：落地页的场景下，不执行获取定位信息操作
      const cityInfo = (isH5App
        && window.location.hash.includes(RouterV2Enum.marketPage)) ? {} : await getCityInfo();

      const localDeviceKey = String(LocalEnum.updatedDevice)
        + String(store.state.base.originUserInfo.mobile || '')
        + String(appVersion)
        + String(pkg.version);

      updateModuleState('base', {
        cityInfo,
      });

      // 目前仅APP支持获取设备信息
      if (platform.isHelloApp) {
        // @ts-ignore
        const [fingerprintHash, deviceInfo] = await Promise.all<
          // @ts-ignore
          { [key: string]: string },
          NativeModel.DeviceInfo | { identifier: string }
        >([
          platform.isHarmony ? {} : getDeviceFingerprintHash(),
          versionCompare(appVersion, '5.15.0') >= 0
            ? await getDeviceInfo()
            : await getOldDeviceInfo(),
        ]);

        // 上报设备信息埋点
        // 协助定位当前设备信息字段有问题是客户端返回问题，还是前端处理机制问题
        ubtButton(
          'Bootstrap',
          'finance_getDeviceInfo',
          'deviceInfo',
          JSON.stringify(deviceInfo),
        );

        updateModuleState('base', {
          deviceInfo,
          fingerprintHash,
        });
      } else if (platform.isAlipayMini) {
        // 在支付宝小程序中获取设备信息;
        const stystemInfo = await getSystemInfo();
        updateModuleState('base', {
          deviceInfo: stystemInfo,
        });
      }

      // 支付包小程序-银河暂不依赖设备信息
      if (!(platform.isAlipayMini || platform.isDingTalk) && !local.get(localDeviceKey)) {
        if (
          isUserDeviceNotEmpty(cityInfo)
          || isUserDeviceNotEmpty(store.getters['base/devicesJSON'])
        ) {
          local.set(localDeviceKey, true, 60 * 60 * 24);
          // TODO：先简单处理，有token再调用；对于token失效异常信息的捕获
          const { token } = store.state.base;
          if (token) {
            UserDeviceApi.update().catch(() => {
              // 避免出现异常的时候阻塞页面正常显示
            });
          }
        }
      }
    } catch (e) {
      ubtButton('Bootstrap', 'getDeviceInfo', 'error', JSON.stringify(e));
      Toast('获取不到APP信息,请刷新');
    }
  }

  static initH5UUID(): void {
    const storeKey = 'h5_uuids';

    if (!localStorage.getItem(storeKey)) {
      localStorage.setItem(
        storeKey,
        `${new Date().valueOf()}${Math.floor(Math.random() * 10000)}`,
      );
    }

    updateModuleState('base', {
      h5UUids: localStorage.getItem(storeKey),
    });
  }

  /**
   * 1. 是否走生产环境网关测试来
   * 2. 获取对用的金融用户登录信息
   */
  static async throughGate(financeUserData?: NativeModel.FinanceUser): Promise<void> {
    try {
      const { token, firstLogin } = store.state.base.originUserInfo; // 哈啰平台用户 token
      // 链接中加上proGate=1，指定使用生产的网关地址；用于灰度测试。
      // eslint-disable-next-line no-restricted-globals
      const isDebugProGate = /(\?|&)proGate=1(&|$)/.test(location.search);
      // 钉钉场景，无平台 token TODO://后续接入平台 token 后，改造
      if (token && !platform.isDingTalk) {
        const financeUser = financeUserData ? {
          data: {
            ...financeUserData,
          },
        } : await getFinanceUser(
          token,
          isDebugProGate
            ? gatewayUrl.replace(/\/\/(fat|uat|dev)-/, '//')
            : undefined,
          landData.getSouce(),
          firstLogin || 0, // 客户端场景，无值，默认传0
        );

        Bootstrap.userReject(financeUser);
      } else {
        // 钉钉场景，无平台 token TODO://后续接入平台 token 后，改造
        if (platform.isDingTalk) {
          // 获取链接上带的三要素，校验用户是否已授权，
          // 授权成功的直接置换金融 token，未授权的，跳转钉钉页面授权后再次置换金融token
          const {
            ciphertext, signData, randomKey, authCode, error,
          } = URLUtils.getQueryMap();

          if (ciphertext) {
            // 钉钉免登录场景，先清空本地原先的哈啰用户登录缓存
            updateModuleState('base', {
              originUserInfo: {},
            });
            // 链接上有参数时，不管是否有 token，都走钉钉免登录授权流程，置换最新的金融用户 token

            // 钉钉授权拒绝场景，重新跳转构建链接 让用户重新授权
            if (error === 'access_denied') {
              const redirectUrl = session.get('redirectUrl') as string;
              window.location.replace(redirectUrl);
            } else {
              const loginParams = {
                ciphertext,
                signData,
                randomKey,
                tmpAuthCode: authCode,
                redirectUrl: window.location.href,
              };
              const financeUser = await DingTalkApi.dingTalkLogin(loginParams);

              // 上报钉钉场景 用户授权状态曝光埋点数据
              moduleExpose(
                'finance_alimini_tagless_home',
                'finance_DingH5authorizationfailed',
                'md5Phone',
                financeUser.data.phoneMd5,
                'authStatus',
                String(financeUser.data.isGrant),
              );

              // TODO:token 置换失效场景 待处理 catch
              // 是否钉钉已授权
              if (financeUser.data.isGrant) {
                Bootstrap.userReject(financeUser);
              } else {
                const { redirectUrl } = financeUser.data || {};
                // 未授权场景，跳转钉钉构造授权链接
                if (redirectUrl) {
                  // 缓存构造链接，供拒绝授权场景，重新跳转使用
                  session.set('redirectUrl', redirectUrl);
                  window.location.replace(redirectUrl);
                }
              }
            }
          } else {
            // 链接上无参数时，有 token，走 token, 无token 场景，不会进来
            if (token) {
              const financeUser = await getFinanceUser(
                token,
                isDebugProGate
                  ? gatewayUrl.replace(/\/\/(fat|uat|dev)-/, '//')
                  : undefined,
                landData.getSouce(),
                firstLogin || 0, // 客户端场景，无值，默认传0
              );

              Bootstrap.userReject(financeUser);
            }
          }
        }
      }
    } catch (e) {
      // 静默
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  static userReject(financeUser: any): void {
    if (financeUser.code === ErrorTypeEnum.LOG_OUT) {
      /** 注销场景，移除native loading */
      removeContainerLoading();
      // 用户已注销账号
      updateModuleState('base', {
        isLogoutUser: true,
      });
    } else if (financeUser.code === ErrorTypeEnum.LOGIN_OVERDUE) {
      /** token失效场景，移除native loading */
      removeContainerLoading();
      Toast.fail(formatToastOption((financeUser).msg));
      // 预留时间供 toast 展示
      setTimeout(() => {
        // app、 支付宝小程序 token 失效时
        if (platform.isHelloApp || platform.isAlipayMini) {
          if (platform.isAlipayMini) {
            closeWebView();
          } else {
            logout();
          }
        } else {
          // h5 token 失效时，跳转登录页
          router.push({
            name: RouterH5Enum.login,
          });
        }
      }, 2400);
    } else {
      updateModuleState('base', {
        isLogoutUser: false,
      });
      Bootstrap.initLoginUser(store.state.base.originUserInfo, financeUser.data);
    }
  }


  // 将哈啰用户登录信息以及金融用户登录信息写入状态数据
  static initLoginUser(
    hellobike: NativeModel.OriginUserInfo,
    finance: NativeModel.FinanceUser,
    // 是否持久化存储到localStorage
    persisted = true,
  ): void {
    const {
      token = '', uid = '', userId = '', phone,
    } = finance || {};
    // 修复在h5登陆场景下,userGuid无值，取guid;
    if (hellobike) {
      hellobike.userGuid = hellobike.userGuid || hellobike.guid || finance.userGuid || '';
      // 钉钉场景 手机号取金融的账户手机号 先取金融的手机号 再取平台的
      hellobike.mobile = phone || hellobike.mobile;
    }

    updateModuleState('base', {
      token,
      uid,
      userId,
      originUserInfo: hellobike,
    });

    // 登录成功之后做数据持久化存储
    usePersistedState();

    if (persisted) {
      local.set(LocalEnum.FinanceUser, { hellobike, finance }, finance.expiresIn);
    }
  }

  // 同步H5中缓存的数据
  static hydrateAuthDataForH5App(): void {
    const authData: Dictionary = local.get(LocalEnum.FinanceUser) || Object.create(null);
    const finance = authData.finance as NativeModel.FinanceUser;
    const hellobike = authData.hellobike as NativeModel.OriginUserInfo;
    if (finance && hellobike) {
      Bootstrap.initLoginUser(hellobike, finance, false);
    }
    // 小程序无可用授信渠道跳转优化
    const { userGuid } = URLUtils.getQueryMap();
    if (userGuid && !hellobike) {
      updateModuleState('base', {
        originUserInfo: {
          userGuid,
        },
      });
    }
  }
}
